export default __webpack_public_path__ + "57c4a6010d6e6ab13cce9b8891a36813.svg";